/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable max-len */
// This file should be removed once the code gen starts generating baseController
import { useMemo } from 'react';
import {
  APIResponse, APIResponseClass, WeeklyBGScheduleTemplate, PageResponse, weeklyBGScheduleTemplateService,
} from '../../../uc-api-sdk';
import {
  MakeRequestHookConfig, UseRequestFactory, useRequestFactory,
  BaseSearchParams, BaseAPIResponse, AjaxOptions,
} from '../../../uc-api-sdk/staticFiles/useReqHook';

export const createWeeklyBGScheduleTemplateObject = (value: APIResponse<PageResponse<WeeklyBGScheduleTemplate>>) => new APIResponseClass<unknown>(value);

export const useWeeklyBGScheduleTemplate = <RCN = undefined>(configs: MakeRequestHookConfig<BaseSearchParams<WeeklyBGScheduleTemplate>, AjaxOptions, RCN>) => {
  const baseConfigs: UseRequestFactory<
    BaseSearchParams<WeeklyBGScheduleTemplate>,
    BaseAPIResponse<PageResponse<WeeklyBGScheduleTemplate>>,
    // @ts-ignore
    typeof weeklyBGScheduleTemplateService.search,
    AjaxOptions,
    APIResponseClass<unknown>
  > = useMemo(() => ({
    reqFunc: (...args: Parameters<typeof weeklyBGScheduleTemplateService.search>) => (
      weeklyBGScheduleTemplateService.search(...args)
    ),
    ResponseClassCreator: createWeeklyBGScheduleTemplateObject,
    typeName: 'useWeeklyBGScheduleTemplate',
  }), []);

  // @ts-ignore
  return useRequestFactory(baseConfigs, configs);
};
